import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { getFrameworkAppSettings } from '../fasApi';
import { COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE } from '../constants';
import { LEGACY_COMMENT_OBJECT_TYPES } from '../../../constants/CommentObjectType';
import { registerQuery, useQuery } from 'data-fetching-client';
const FAS_QUERY = registerQuery({
  fieldName: 'collaborationSidebarFAS',
  args: [],
  fetcher: () => getFrameworkAppSettings()
});
export default function useFrameworkAppSettings() {
  "use memo";

  const $ = _c(9);
  const {
    data: appSettingsData,
    loading,
    error
  } = useQuery(FAS_QUERY);
  const appSettings = appSettingsData === null || appSettingsData === void 0 ? void 0 : appSettingsData.collaborationSidebarFAS;
  let t0;
  if ($[0] !== appSettings) {
    t0 = appName => {
      var _appSettings$appName;
      return (appSettings === null || appSettings === void 0 || (_appSettings$appName = appSettings[appName]) === null || _appSettings$appName === void 0 || (_appSettings$appName = _appSettings$appName[COLLABORATION_SIDEBAR_FAS_NAMESPACE]) === null || _appSettings$appName === void 0 ? void 0 : _appSettings$appName.metadata) || null;
    };
    $[0] = appSettings;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getCollaborationSidebarAppSetting = t0;
  let t1;
  if ($[2] !== appSettings) {
    t1 = objectTypeId => {
      var _appSettings$objectTy;
      if (LEGACY_COMMENT_OBJECT_TYPES.includes(objectTypeId)) {
        return {
          enabled: {
            value: true
          }
        };
      }
      return (appSettings === null || appSettings === void 0 || (_appSettings$objectTy = appSettings[objectTypeId]) === null || _appSettings$objectTy === void 0 || (_appSettings$objectTy = _appSettings$objectTy[COMMENTING_FAS_NAMESPACE]) === null || _appSettings$objectTy === void 0 ? void 0 : _appSettings$objectTy.metadata) || null;
    };
    $[2] = appSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getCommentingAppSetting = t1;
  let t2;
  if ($[4] !== error || $[5] !== getCollaborationSidebarAppSetting || $[6] !== getCommentingAppSetting || $[7] !== loading) {
    t2 = {
      getCollaborationSidebarAppSetting,
      getCommentingAppSetting,
      loading,
      error
    };
    $[4] = error;
    $[5] = getCollaborationSidebarAppSetting;
    $[6] = getCommentingAppSetting;
    $[7] = loading;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}